const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      try {
        if (typeof getCLS === 'function') getCLS(onPerfEntry);
        if (typeof getFID === 'function') getFID(onPerfEntry);
        if (typeof getFCP === 'function') getFCP(onPerfEntry);
        if (typeof getLCP === 'function') getLCP(onPerfEntry);
        if (typeof getTTFB === 'function') getTTFB(onPerfEntry);
      } catch (error) {
        console.warn('Web Vitals tracking error:', error);
      }
    }).catch((error) => {
      console.warn('Failed to load web-vitals:', error);
    });
  }
};

export default reportWebVitals;
